import { render, staticRenderFns } from "./NewAppPackageExpansionsManager.vue?vue&type=template&id=0a0db09f"
import script from "./NewAppPackageExpansionsManager.vue?vue&type=script&lang=js"
export * from "./NewAppPackageExpansionsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports